import React from 'react';

import './index.css';

const Contact = () => (
  <div className="Contact">
    <h1>Contact Me</h1>
    <p>
      If you would like to get in touch, please send me an email
      at <a href="mailto:mikelowedev@gmail.com">mikelowedev@gmail.com</a>.
    </p>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/index.jsx